<h2 *ngIf="!isLoading && parameterConfigs.parameters_from_definition">Parameters <span class="select-all-note">Note: To include all values (including nulls), leave the filter unselected and do not select all.</span></h2>

<!-- Loading state -->
<div *ngIf="isLoading" class="parameters-loading">
    <div class="loading-spinner"></div>
    <span class="loading-text">Loading parameters...</span>
</div>

<!-- Parameters content -->
<div *ngIf="!isLoading" [formGroup]="parametersForm" class="parameter-options">
    <div *ngFor="let column of parameterConfigs.parameters_from_definition" class="parameter-container">
        <div class="parameter-column">
            <!-- TextArea control type -->
            <div *ngIf="column.controlType === 'TextArea'" [class.parameter-error]="hasError(getTextAreaParamName(column))">
                <f-textarea
                    [uuid]="getTextAreaParamName(column)"
                    [value]="getTextAreaValue(column)"
                    [attr.label-text]="column.label"
                    [attr.helper-text]="'Enter values separated by commas'"
                    [attr.error-message]="hasError(getTextAreaParamName(column)) ? getErrorMessage(getTextAreaParamName(column)) : null"
                    [attr.required]="isParameterRequired(getTextAreaParamName(column)) ? true : null"
                    (textareaChanged)="onTextAreaChanged($event, getTextAreaParamName(column))">
                </f-textarea>
                <div *ngIf="hasError(getTextAreaParamName(column))" class="inline-error-message">
                    {{getErrorMessage(getTextAreaParamName(column))}}
                </div>
            </div>

            <!-- DateTimeParameterDeclaration -->
            <div *ngIf="column.DateTimeParameterDeclaration" [class.parameter-error]="hasError(column.DateTimeParameterDeclaration.Name)">
                <div>{{column.label}} <span *ngIf="isParameterRequired(column.DateTimeParameterDeclaration.Name)" class="required">*</span></div>
                <input type="date" class="parameter-column" (change)="updateParameters()"
                    [formControlName]="column.DateTimeParameterDeclaration.Name" />
                <div *ngIf="hasError(column.DateTimeParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.DateTimeParameterDeclaration.Name)}}
                </div>
            </div>
            
            <!-- StringParameterDeclaration SINGLE_VALUED -->
            <div
                *ngIf="column.StringParameterDeclaration && column.StringParameterDeclaration.ParameterValueType === 'SINGLE_VALUED' && column.controlType !== 'TextArea'"
                [class.parameter-error]="hasError(column.StringParameterDeclaration.Name)">
                <input *ngIf="!column.options"
                    [type]="column.StringParameterDeclaration.Name === 'pStartDate' ? 'date' : 'text'"
                    class="parameter-column" (change)="updateParameters()"
                    [formControlName]="column.StringParameterDeclaration.Name" />
                <f-dropdown *ngIf="column.options"
                    [items]="getStringDropdownItems(column)"
                    [attr.label-text]="column.label"
                    [attr.input-id]="column.StringParameterDeclaration.Name"
                    [attr.toggle-id]="column.StringParameterDeclaration.Name + '-toggle'"
                    [attr.error-message]="hasError(column.StringParameterDeclaration.Name) ? getErrorMessage(column.StringParameterDeclaration.Name) : null"
                    [attr.required]="isParameterRequired(column.StringParameterDeclaration.Name) ? true : null"
                    (dropdownValueChanged)="onDropdownValueChanged($event, column.StringParameterDeclaration.Name, false)"
                    class="parameter-select-menu">
                </f-dropdown>
                <div *ngIf="hasError(column.StringParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.StringParameterDeclaration.Name)}}
                </div>
            </div>

            <!-- StringParameterDeclaration MULTI_VALUED -->
            <div
                *ngIf="column.StringParameterDeclaration && column.StringParameterDeclaration.ParameterValueType === 'MULTI_VALUED' && column.StringParameterDeclaration.Name && column.controlType !== 'TextArea'"
                [class.parameter-error]="hasError(column.StringParameterDeclaration.Name)">
                <f-dropdown
                    [items]="getStringDropdownItems(column)"
                    [multiple]="true"
                    [selectAll]="true"
                    [attr.label-text]="column.label"
                    [attr.input-id]="column.StringParameterDeclaration.Name"
                    [attr.toggle-id]="column.StringParameterDeclaration.Name + '-toggle'"
                    [attr.error-message]="hasError(column.StringParameterDeclaration.Name) ? getErrorMessage(column.StringParameterDeclaration.Name) : null"
                    [attr.required]="isParameterRequired(column.StringParameterDeclaration.Name) ? true : null"
                    (dropdownValueChanged)="onDropdownValueChanged($event, column.StringParameterDeclaration.Name, true)"
                    class="parameter-select-menu">
                </f-dropdown>
                <div *ngIf="hasError(column.StringParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.StringParameterDeclaration.Name)}}
                </div>
            </div>

            <!-- IntegerParameterDeclaration SINGLE_VALUED -->
            <div
                *ngIf="column.IntegerParameterDeclaration && column.IntegerParameterDeclaration.ParameterValueType === 'SINGLE_VALUED'"
                [class.parameter-error]="hasError(column.IntegerParameterDeclaration.Name)">
                <div>{{column.label}} <span *ngIf="isParameterRequired(column.IntegerParameterDeclaration.Name)" class="required">*</span></div>
                <input type="number" class="parameter-column" (change)="updateParameters()"
                    [formControlName]="column.IntegerParameterDeclaration.Name" />
                <div *ngIf="hasError(column.IntegerParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.IntegerParameterDeclaration.Name)}}
                </div>
            </div>

            <!-- IntegerParameterDeclaration MULTI_VALUED -->
            <div
                *ngIf="column.IntegerParameterDeclaration  && column.IntegerParameterDeclaration.ParameterValueType === 'MULTI_VALUED'"
                [class.parameter-error]="hasError(column.IntegerParameterDeclaration.Name)">
                <f-dropdown
                    [items]="getIntegerDropdownItems(column)"
                    [multiple]="true"
                    [selectAll]="true"
                    [attr.label-text]="column.label"
                    [attr.input-id]="column.IntegerParameterDeclaration.Name"
                    [attr.toggle-id]="column.IntegerParameterDeclaration.Name + '-toggle'"
                    [attr.error-message]="hasError(column.IntegerParameterDeclaration.Name) ? getErrorMessage(column.IntegerParameterDeclaration.Name) : null"
                    [attr.required]="isParameterRequired(column.IntegerParameterDeclaration.Name) ? true : null"
                    (dropdownValueChanged)="onDropdownValueChanged($event, column.IntegerParameterDeclaration.Name, true)"
                    class="parameter-select-menu">
                </f-dropdown>
                <div *ngIf="hasError(column.IntegerParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.IntegerParameterDeclaration.Name)}}
                </div>
            </div>
        </div>
    </div>
</div>

<!-- No parameters message -->
<div *ngIf="!isLoading && (!parameterConfigs.parameters_from_definition || parameterConfigs.parameters_from_definition.length === 0)">
    <p>No parameters available for this dashboard.</p>
</div>
